import React, { useContext } from 'react'
import { Button, Container, Box, Flex} from 'theme-ui'
import pageContextProvider from '../../helpers/pageContextProvider'
import { HeaderLogo } from './Header.Logo'
import { HeaderMenu } from './Header.Menu'
const styles = {
    wrapper: {
      position: `relative`,
      bg: `headerBg`
    },
    container: {
      position: `relative`,
      zIndex: 10
    },
    logoContainer: {
      flexBasis: [`full`, null, `1/6`]
    },
    menuContainer: {
      flexBasis: [`auto`, 'auto', `1/3`],
      minWidth: `fit-content`,
      order: [4, null, `unset`],
      mr: 3
    },
    colorModeContainer: {
      display: [`block`, null , `block`],
      minWidth: `auto`,
      order: [2, null, `unset`]
    },

  }

  export const Header = ({ children }) => {

    const context = useContext(pageContextProvider)

    const {mobileMenu } = context.pageContext

    return (
        <Box sx={styles.wrapper} id='header'>
          <Container variant='compact' sx={styles.container}>
            <Flex variant='layout.header'>
              <Box sx={styles.logoContainer}>
                <HeaderLogo />
              </Box>
              <Box sx={styles.menuContainer}>
                <HeaderMenu mobileMenu={mobileMenu} />
              </Box>
              <Box>
                <Button sx={{display:['none','block']}} as='a' href='https://www.paypal.com/donate/?hosted_button_id=7GN5DXUB25RV8' target='_blank' rel= 'noopener noreferrer'>Donate</Button>
              </Box>
              {/* <Box sx={styles.colorModeContainer}>
              <HeaderColorMode />
              </Box> */}
            </Flex>
          </Container>
          {children}
        </Box>
      )
    }